module.exports = __webpack_public_path__ + "img/normal_multiplier.0d3ae61c.png";